import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';


export class BinaryComponent extends GeneralExerciseComponent {

  searchType: string;
  elementType: string;
  requestedElement: any;
  elements: any[] = [];
  count: number;

  linearInterpolation: boolean;
  limitRange: boolean;
  computeMiddle: boolean;

  limitedRange: number[] = [];
  middle: number;

  openCard: number;
  counter: number = 0;
  minCounterBinary: number;
  minCounterFibonacci: number;
  minCounterLinear: number = 0;

  ficonaccis = [0, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, 233, 377, 610, 987, 1597];

  constructor(protected activatedRoute: ActivatedRoute, protected messageService: MessageService, protected topicService: TopicService, protected http: HttpClient) {
    super(activatedRoute, topicService, messageService);
  }

  /** Loads the typespecific Information from the configuration */
  setTypeSpecificsFromConfiguration() {
    this.searchType = this.configuration.typespecifics.type;
    this.elementType = this.configuration.typespecifics.elementType;
    this.requestedElement = this.configuration.typespecifics.requestedElement;
    this.elements = [...this.configuration.typespecifics.elements];
    this.elements = this.elements.sort();
    if (this.elementType == 'number') {
      this.elements = this.elements.sort((a, b) => +a - +b);
    }
    this.count = this.elements.length + 1;
    this.limitRange = this.configuration.typespecifics.limitRange;
    this.computeMiddle = this.configuration.typespecifics.computeMiddle;
    this.limitedRange = this.createArray(this.elements.length);
    this.openCard = undefined;
    this.counter = 0;
    this.computeTime();
    this.computeMiddleElement();
  }

  /** Loades the typespecifig information given by the state */
  setTypeSpecificsFromState() {
    if (this.state.typespecific != undefined) {
      if (this.state.typespecific.limitedRange != undefined) {
        this.limitedRange = this.state.typespecific.limitedRange;
      }
      if (this.state.typespecific.counter != undefined) {
        this.counter = this.state.typespecific.counter;
      }
    }
    if (this.state.solved) {
      this.openCard = this.elements.indexOf(this.requestedElement);
    } else {
      this.openCard = this.state.typespecific.openCard;
    }
  }

  /** computes the typespecific part of the state */
  computeState() {
    this.state.typespecific.limitedRange = this.limitedRange;
    this.state.typespecific.counter = this.counter;
    this.state.typespecific.openCard = this.openCard;
  }


  /** returns the achieved and the maximal possible points */
  evaluate(): number[] {
    let points = 0;
    let maxPoints = 2;
    if (this.solved) {
      points = 2;
      if (this.counter > this.correctCounter()) {
        points = Math.max(0, points - (this.counter - this.correctCounter()) * 0.5);
      }
    }
    if (this.searchType == 'fibonacci') {
      maxPoints = maxPoints * 1.5;
      points = points * 1.5;
    }
    if (this.searchType == 'linear') {
      maxPoints = maxPoints * 2;
      points = points * 2;
    }
    return [points, maxPoints];
  }

  /** returns the max counter for selected method */
  correctCounter(): number {
    switch (this.searchType) {
      case "binary": return this.minCounterBinary;
      case "fibonacci": return this.minCounterFibonacci;
      case "linear": return this.minCounterLinear;
    }
  }

  checkSolution() {
    this.messageService.addAlertWithTimeout(this.get("notFoundYet"), "danger", 10000);
  }

  /** computes the next card to open, based on the searchType */
  computeMiddleElement() {
    if (this.searchType == "binary") {
      this.middle = Math.ceil((this.limitedRange[0] + this.limitedRange[this.limitedRange.length - 1]) / 2 + 1);
    }
    else if (this.searchType == "fibonacci") {
      let smallestFibonacci = this.getFibonacciSplit(this.limitedRange.filter(v => Math.floor(v) == v).length);
      this.middle = this.limitedRange.filter(v => Math.floor(v) == v)[0] + smallestFibonacci;
    } else {
      if (this.counter == 0) {
        this.middle = 1;
      } else if (this.counter == 1) {
        this.middle = this.elements.length;
      } else {
        let myLimitedRange = this.limitedRange.filter(v => Math.floor(v) == v);
        let min = Math.max(myLimitedRange[0] - 1, 0);
        let max = Math.min(myLimitedRange[myLimitedRange.length - 1] + 1, this.elements.length - 1);
        this.middle = myLimitedRange[0] + Math.ceil(((this.requestedElement - this.elements[min]) /
          (this.elements[max] - this.elements[min])) * (myLimitedRange.length));
      }
    }
    if (Number.isNaN(this.middle)) {
      this.middle = -1;
    }
  }

  /** returns the fibonacci split */
  getFibonacciSplit(length: number): number {
    let smallestFibonacci = this.ficonaccis.map((v, i) => [v, i]).filter((v) => v[0] >= length)[0];
    if (smallestFibonacci[1] > 2) {
      return this.ficonaccis[smallestFibonacci[1] - 2];
    } else {
      return 1;
    }
  }

  /**computes the time, the copmuter needs to find the card */
  computeTime() {
    let a = 0;
    let b = this.elements.length;
    let c = Math.ceil((a + b) / 2);
    this.minCounterBinary = 1;
    let i = 0;
    while (this.elements[c] != this.requestedElement && a < b) {
      this.minCounterBinary++;
      if (this.elements[c] > this.requestedElement) {
        b = c - 1;
      } else {
        a = c + 1;
      }
      c = Math.ceil((a + b) / 2);
      i++;
    }
    i = 0;
    a = 0;
    b = this.elements.length;
    c = this.getFibonacciSplit(b - a) - 1;
    this.minCounterFibonacci = 1;
    while (this.elements[c] != this.requestedElement && i < 30 && a < b) {
      this.minCounterFibonacci++;
      if (this.elements[c] > this.requestedElement) {
        b = c - 1;
      } else {
        a = c + 1;
      }
      c = a + this.getFibonacciSplit(b - a + 1) - 1;
      i++;

    }
    if (this.elementType == 'number') {
      a = 0;
      b = this.elements.length;
      let myLimitedRange = this.limitedRange.filter(v => Math.floor(v) == v);
      let min = Math.max(myLimitedRange[0] - 1, 0);
      let max = Math.min(myLimitedRange[myLimitedRange.length - 1] + 1, this.elements.length - 1);
      c = a + Math.ceil(((this.requestedElement - this.elements[min]) / (this.elements[max] - this.elements[min])) * (this.limitedRange.length));
      this.minCounterLinear = 3;

      i = 0;
      while (this.elements[c] != this.requestedElement && i < 10 && this.elements[min] < this.requestedElement) {

        myLimitedRange = myLimitedRange.filter((v) => ((this.elements[c] >= this.requestedElement) == (c >= v))).filter(v => v <= b).filter(v => (v >= a));
        this.minCounterLinear++;
        let min = Math.max(myLimitedRange[0] - 1, 0);
        let max = Math.min(myLimitedRange[myLimitedRange.length - 1] + 1, this.elements.length - 1);
        if (this.elements[c] > this.requestedElement) {
          b = c - 1;
        } else {
          a = c + 1;
        }
        //let min = Math.max(a - 1, 0);
        //let max = Math.min(b + 1, this.elements.length - 1);
        myLimitedRange = myLimitedRange.filter((v) => ((this.elements[c] >= this.requestedElement) == (c >= v))).filter(v => v <= b).filter(v => (v >= a));
        c = myLimitedRange[0] + Math.floor(((this.requestedElement - this.elements[min]) /
        (this.elements[max] - this.elements[min])) * (myLimitedRange.length));

        i++;
      }
    }
  }


  /** opens card i */
  open(i: number) {
    if (this.solved) {
      return;
    }
    this.openCard = i;
    this.counter++;
    this.limitedRange = this.limitedRange.filter((v) => ((this.elements[i] >= this.requestedElement) == (i >= v)));
    if (this.elements[i] == this.requestedElement) {
      this.messageService.addAlertWithTimeout(this.get("elementFound"), "success", 5000);
      if (this.counter <= this.minCounterBinary && this.searchType == "binary") {
        this.messageService.addAlertWithTimeout(this.get("fasterOrEquallyFast"), "success", 5000);
      }
      else if (this.counter <= this.minCounterFibonacci && this.searchType == "fibonacci") {
        this.messageService.addAlertWithTimeout(this.get("fasterOrEquallyFast"), "success", 5000);
      }
      else if (this.counter <= this.minCounterLinear && this.searchType == "linear") {
        this.messageService.addAlertWithTimeout(this.get("fasterOrEquallyFast"), "success", 5000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("slower"), "danger", 5000);
      }
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    } else {
      if (this.limitedRange.includes(i)) {
        this.limitedRange.splice(this.limitedRange.indexOf(i), 1);
      }
    }
    this.computeMiddleElement();
  }

}
